// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607130535/js/" + chunkId + "." + {"44":"8cc91b4c","225":"7efb2242","481":"af91ba22","486":"a4c98173","770":"9d802527"}[chunkId] + ".0.5961120700602526.chunk.js";
};